document.addEventListener('DOMContentLoaded', function () {
    // Function to check if the cart contains a product with the 'autoclave' tag
    function cartContainsAutoclave() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                return cart.items.some(item => {
                    // Safely access the tags property
                    const tags = item.product?.tags || [];
                    return tags.includes('autoclave');
                });
            });
    }

    // Function to remove the upsell product from the cart
    // function removeUpsellProduct() {
    //     const upsellProductTitle = "KURS Sterylizacji z UPRAWNIENIAMI";
    //     fetch('/cart.js')
    //         .then(response => response.json())
    //         .then(cart => {
    //             const upsellProduct = cart.items.find(item => item.product_title === upsellProductTitle);
    //             if (upsellProduct) {
    //                 fetch('/cart/change.js', {
    //                     method: 'POST',
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Accept': 'application/json'
    //                     },
    //                     body: JSON.stringify({
    //                         id: upsellProduct.key,
    //                         quantity: 0
    //                     })
    //                 }).then(response => {
    //                     if (response.ok) {
    //                         window.location.reload(); // Reload the page to reflect the changes
    //                     }
    //                 });
    //             }
    //         });
    // }

    // Check if the cart contains an autoclave product and remove the upsell product if not
    // cartContainsAutoclave().then(containsAutoclave => {
    //     if (!containsAutoclave) {
    //         // removeUpsellProduct();
    //     }
    // });

    // Listen for cart updates (e.g., when a product is removed)
    // document.addEventListener('click', function (event) {
    //     if (event.target.classList.contains('cart__remove') || event.target.closest('.cart__remove')) {
    //         setTimeout(() => {
    //             cartContainsAutoclave().then(containsAutoclave => {
    //                 if (!containsAutoclave) {
    //                     removeUpsellProduct();
    //                 }
    //             });
    //         }, 2000); // Delay to allow the cart to update
    //     }
    // });
});



